// Vendor imports
const isURL = require('validator/lib/isURL')
// Client lib imports
const { FriendlyRequestError } = require('client/lib/request')
// Client V2 common imports
const articleActions = require('client-v2/common/models/article/actions')
const collectionSelectModalActions = require('client-v2/common/containers/collection-select-modal/actions')
const collectionSelectModalAPI = require('client-v2/common/containers/collection-select-modal/api')
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const {
  ARTICLE_IS_MIXED_CHANGE_PENDING,
  showCollectionSelectModal
} = require('client-v2/common/models/article/actions')
const { userProfilePostModalHref } = require('client-v2/common/models/user/actions')
// Sibling imports
const selectors = require('./selectors')

// Action types

const SHOW = 'CONTENT_ADD_MODAL_SHOW'
const HIDE = 'CONTENT_ADD_MODAL_HIDE'
const ARTICLE_FAILED = 'CONTENT_ADD_MODAL_ARTICLE_FAILED'
const ARTICLE_LOADED = 'CONTENT_ADD_MODAL_ARTICLE_LOADED'
const ARTICLE_LOADING = 'CONTENT_ADD_MODAL_ARTICLE_LOADING'
const SUBMIT_FAILED = 'CONTENT_ADD_MODAL_SUBMIT_FAILED'
const SUBMIT_LOADED = 'CONTENT_ADD_MODAL_SUBMIT_LOADED'
const SUBMIT_INVALID_URL = 'CONTENT_ADD_MODAL_SUBMIT_INVALID_URL'
const SUBMIT_LOADING = 'CONTENT_ADD_MODAL_SUBMIT_LOADING'
const SET_URL_TEXT = 'CONTENT_ADD_MODAL_SET_URL_TEXT'

// Action creators

function hide() {
  return {
    type: HIDE
  }
}

function setUrlText(url) {
  return {
    type: SET_URL_TEXT,
    payload: url
  }
}

function show(options = {}) {
  return {
    type: SHOW,
    payload: {
      url: options.url || ''
    }
  }
}

// Action dispatchers

function confirmUnmix() {
  return async function (dispatch) {
    await dispatch(collectionSelectModalActions.confirmUnmix())
    dispatch(hide())
  }
}

function fetchArticle() {
  return async function (dispatch, getState) {
    const url = selectors.url(getState())
    if (url) {
      if (!isURL(url || '', {
        'require_valid_protocol': false,
        'allow_protocol_relative_urls': true
      })) {
        return dispatch({
          type: SUBMIT_INVALID_URL
        })
      }
      dispatch({
        type: ARTICLE_LOADING
      })
      try {
        dispatch({
          type: ARTICLE_LOADED,
          payload: await collectionSelectModalAPI.extractArticleFromUrl(url)
        })
      } catch (err) {
        dispatch({
          type: ARTICLE_FAILED,
          payload: url
        })
        throw err
      }
    }
  }
}

function retryFetch() {
  return async function (dispatch) {
    dispatch({
      type: ARTICLE_LOADING
    })
    setTimeout(() => {
      dispatch(fetchArticle())
    }, 1000)
  }
}

function submit() {
  return async function (dispatch, getState) {
    const state = getState()
    if (selectors.isSubmitPending(state)) {
      return // Submission is already in-progress
    }
    dispatch({
      type: ARTICLE_IS_MIXED_CHANGE_PENDING
    })
    try {
      let isAddedToProfile = false
      let article = selectors.article(state)
      const urlId = selectors.urlId(state)
      if (!selectors.isArticleMixed(state)) {
        const result = await collectionSelectModalAPI.addToMixedCollection({ urlId })
        article = result.post
        isAddedToProfile = true
        dispatch(articleActions.articleUpdated(article))
        dispatch(articleActions.articleMixed(article))
      }
      dispatch(showCollectionSelectModal({ article }))
      dispatch({
        type: SUBMIT_LOADED,
        payload: {
          isAddedToProfile,
          postHref: userProfilePostModalHref(state.user, urlId)
        }
      })
    } catch (err) {
      dispatch({
        type: SUBMIT_FAILED
      })
      const message = err instanceof FriendlyRequestError
      ? err.message
      : 'Something went wrong. Please try again.'
      dispatch(confirmModalActions.alert({
        heading: 'Content submission failed',
        subheading: message
      }))
      throw err
    }
  }
}

// Exports

module.exports = {
  // Action types
  SHOW,
  HIDE,
  ARTICLE_FAILED,
  ARTICLE_LOADED,
  ARTICLE_LOADING,
  SUBMIT_FAILED,
  SUBMIT_INVALID_URL,
  SUBMIT_LOADED,
  SUBMIT_LOADING,
  SET_URL_TEXT,
  // Action creators
  hide,
  setUrlText,
  // Action dispatchers
  confirmUnmix,
  fetchArticle,
  retryFetch,
  show,
  submit
}
